/**
 * CHECKBOX TOGGLE ENTRY PAGE
 */

const cbToggle = () => {
  const toggleGroups = document.querySelectorAll<HTMLElement>('.entry__form-input-field--checkbox');

  toggleGroups.forEach(group => {
    const radioButtons = group.querySelectorAll<HTMLInputElement>('input.radio-toggle');

    radioButtons.forEach(radio => {
      radio.addEventListener('change', () => {
        // Remove 'checked' class from all containers in the same group
        group.querySelectorAll<HTMLElement>('.entry__form-checkbox-container, .mwform-radio-field.horizontal-item').forEach(container => {
          container.classList.remove('checked');
        });

        // Add 'checked' class to the container of the checked radio button
        if (radio.checked) {
          const closestContainer = radio.closest<HTMLElement>('.entry__form-checkbox-container, .mwform-radio-field.horizontal-item');
          if (closestContainer) {
            closestContainer.classList.add('checked');
          }
        }
      });
    });
  });
};

export default cbToggle;
